// extracted by mini-css-extract-plugin
export default {"chip":"style_chip__RcY+s","value":"style_value__pT408"};